import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getRMAprobadoPOA(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'rmAprobadoPOA/' + id, { headers: this.header(this.token) });
  }

  getTareasProgramadasPorPOA(id: number, mesId: number): Observable<any> {
    return this.http.get(this.baseUrl + 'tareasProgramadasPorPOA/' + id + '/' + mesId, { headers: this.header(this.token) });
  }


  getPoaTechoByUser(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTechoByUser', { headers: this.header(this.token) });
  }

  getOperacionesByAE(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'poaOperacionesByAeId/' + id, { headers: this.header(this.token) });
  }

  getTechoByUOByTipoAgregacion(id: number, tipo_agregacion: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTechoByUOByTipoAgregacion/' + id + '/' + tipo_agregacion, { headers: this.header(this.token) });
  }

  getTechosByGestionId(gestionId: number): Observable<any> {
    return this.http.get(this.baseUrl + 'techosByGestionId/' + gestionId, { headers: this.header(this.token) });
  }
  getTechoByUO(tipo_agregacion_id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTechoByUnidadOrganizacional/' + tipo_agregacion_id, { headers: this.header(this.token) });
  }

  getTechoByGestionId(): Observable<any> {
    return this.http.get(this.baseUrl + 'techosByGestionId', { headers: this.header(this.token) });
  }
  getPoaTechoByUOId(tipo_agregacion_id): Observable<any> {
    return this.http.get(this.baseUrl + 'getPoaTechoByUOId/' + tipo_agregacion_id, { headers: this.header(this.token) });
  }
  getTechoGetionSiguiente(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTechoGestionSiguiente/' + id, { headers: this.header(this.token) });
  }

  //fRnk
  getPoaTechoById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTechoById/' + id, { headers: this.header(this.token) });
  }

  updateEstadoTecho(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaTechoEnviarARevision', bodyString, { headers: this.header(this.token) });
  }

  updateEstadoTechoJue(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'putEstadoTecho', bodyString, { headers: this.header(this.token) });
  }



  getDataEjecucionMensual(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'datosEjecucionMesesByTechoId/' + id, { headers: this.header(this.token) });
  }

  getResumenFUS(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getResumenFUS/' + id , { headers: this.header(this.token) });
  }

  getResumenTFisicos(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'resumenTFisicos/' + id, { headers: this.header(this.token) });
  }

  getResumenTPresupuestarios(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'resumenTPresupuestarios/' + id, { headers: this.header(this.token) });
  }

  getResumenSeguimiento(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'resumenSeguimiento/' + id, { headers: this.header(this.token) });
  }

  getDataMontoDisponibleEjecucion(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'datosGraficos/' + id, { headers: this.header(this.token) });
  }

  getDataResumenEjecucion(id: number, mesId: number): Observable<any> {
    return this.http.get(this.baseUrl + 'dataResumenEjecucion/' + id + '/' + mesId, { headers: this.header(this.token) });
  }

  getGestionesCombo(): Observable<any> {
    return this.http.get(this.baseUrl + 'getGestionesCombo', { headers: this.header(this.token) });
  }

  postUsuarioGestion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'usuarioGestion', bodyString, { headers: this.header(this.token) });
  }

  postPerfilUsuario(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'perfilUsuario', bodyString, { headers: this.header(this.token) });
  }


  postUsuarioPoa(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'userPoa', bodyString, { headers: this.header(this.token) });
  }

  putUsuarioPoa(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'userPoa', bodyString, { headers: this.header(this.token) });
  }

  getPoaGestiones(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaGestiones', { headers: this.header(this.token) });
  }

  getEtapasByGestionId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'etapasByGestionId/' + id, { headers: this.header(this.token) });
  }

  getObservacionesTecho(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'PoaTechoSeguimiento/' + id, { headers: this.header(this.token) });
  }

  getUsuariosAll(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getUsuariosAll/' + id, { headers: this.header(this.token) });
  }

  getUsuariosPoa(): Observable<any> {
    return this.http.get(this.baseUrl + 'getUsuariosPoa', { headers: this.header(this.token) });
  }

  postUsuariosTecho(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postUsuariosTecho', bodyString, { headers: this.header(this.token) });
  }

  getDatosUsuarioById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getDatosUsuarioById', { headers: this.header(this.token) });
  }

  postUserUpdatePass(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postUserUpdatePass', bodyString, { headers: this.header(this.token) });
  }

  getListClaseGasto(): Observable<any> {
    return this.http.get(this.baseUrl + 'getTablaClasesGasto', { headers: this.header(this.token) });
  }

  postRptAvanceFus(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'xls/avanceFus', bodyString, { headers: this.header(this.token) });
  }

  getRoles(): Observable<any> {
    return this.http.get(this.baseUrl + 'getRolesPoa', { headers: this.header(this.token) });
  }

  getEscalaSalarialActivos(): Observable<any> {
    return this.http.get(this.baseUrl + 'escalaSalarialActivos', { headers: this.header(this.token) });
  }


  getPerfiles(): Observable<any> {
    return this.http.get(this.baseUrl + 'perfil', { headers: this.header(this.token) });
  }

  avisosPantallaInicio(id: number) {
    return this.http.get(this.baseUrl + 'notificacionesPantallaInicio/' + id, { headers: this.header(this.token) });
  }

  
  getObservaciones(modulo: string): Observable<any> {
    return this.http.get(this.baseUrl + 'getObservaciones/' + modulo, { headers: this.header(this.token) });
  }

  getObservacionesLstGeneral(): Observable<any> {
    return this.http.get(this.baseUrl + 'getObservacionesLstGeneral', { headers: this.header(this.token) });
  }

  postObservacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postObservacion', bodyString, { headers: this.header(this.token) });
  }

  putObservacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'putObservacion', bodyString, { headers: this.header(this.token) });
  }

  deleteObservacion(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteObservacion/' + id, { headers: this.header(this.token) });
  }



  getODescripcionLstGeneral(): Observable<any> {
    return this.http.get(this.baseUrl + 'getDescripcionesLstGeneral', { headers: this.header(this.token) });
  }

  postDescripcion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postDescripcion', bodyString, { headers: this.header(this.token) });
  }

  putDescripcion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'putDescripcion', bodyString, { headers: this.header(this.token) });
  }

  deleteDescripcion(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteDescripcion/' + id, { headers: this.header(this.token) });
  }


  escalaSalarialActivos(): Observable<any> {
    return this.http.get(this.baseUrl + 'escalaSalarialActivos', { headers: this.header(this.token) });
  }

  postEscala(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postEscala', bodyString, { headers: this.header(this.token) });
  }

  putEscala(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'putEscala', bodyString, { headers: this.header(this.token) });
  }

  deleteEscala(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteEscala/' + id, { headers: this.header(this.token) });
  }


  getAuditoriaTraspasos(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'auditoriaTraspasos/' + id, { headers: this.header(this.token) });
  }
}
